import React, { Component } from 'react'
import { toJS } from 'mobx'
import ImgGallery from '@common/ImgGallery'

export default class extends Component {
  onOk = url => {
    const { onChange } = this.props
    onChange && onChange(this.props.value.concat({ img: url }))
  }

  onRemove = index => {
    const { onChange } = this.props
    const val = [
      ...this.props.value.slice(0, index),
      ...this.props.value.slice(index + 1)
    ]
    onChange && onChange(val)
  }

  render() {
    const { value, ...rest } = this.props
    return (
      <ImgGallery
        {...rest}
        onOk={this.onOk}
        onRemove={this.onRemove}
        imgList={toJS(value)}
      />
    )
  }
}
